import CountryLangCtx from 'app/contexts/countryLang/CountryLangCtx'
import countries from 'app/constants/countries'
import React, { useContext } from 'react'
import 'styles/utils/nowrap.scss'
import './HomepagePromoBanner.scss'
import SVG from 'react-inlinesvg'
import ArrowIcon from 'src/svg/arrow-right.svg'

function HomepagePromoBanner (props) {
  const { country } = useContext(CountryLangCtx)
  const isUS = country === countries.us
  const { onClickCta, tagText, title, body, ctaText, linkText, linkHref, imgSrc, imgSrcSet, imgSizes, imgAlt } = props

  return (
    isUS
      ? (
      <div className='homepage-promo-banner section'>
        <div className='homepage-promo-banner__content'>
          {tagText
            ? <section className='limited-tag'>
            {tagText}
          </section>
            : null}
          <div className='content-wrapper'>
            <div className='content-container'>
              <h1 className='banner-title'>
                {title}
              </h1>
               <p className='banner-text'>
                 {body}
               </p>
            </div>
            <section className='button-container'>
              {ctaText ? <button className='button is-dark is-uppercase' disabled={!onClickCta} onClick={onClickCta}>{ctaText}</button> : null}
              {linkText
                ? <a href={linkHref}
                 className='link button is-uppercase'>
                {linkText}&nbsp;<span className='icon is-small ml-1'>
                  <SVG aria-hidden='true' className='svg-outline' src={ArrowIcon}/>
                </span>
              </a>
                : null}
            </section>
          </div>
        </div>
        <img className='banner-image' src={imgSrc} sizes={imgSizes ?? null} srcSet={imgSrcSet ?? null} alt={imgAlt ?? ''}/>
      </div>)
      : null
  )
}

export default HomepagePromoBanner
